import { render, staticRenderFns } from "./drugsorder.vue?vue&type=template&id=ba58d9fa"
import script from "./drugsorder.vue?vue&type=script&lang=js"
export * from "./drugsorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports